import { types } from "../action-types";

const initialState = {
  loading: false,
  error: null,
  active: [],
  pending: [],
  inactive: [],
  totals: {
    active: 0,
    pending: 0,
    inactive: 0,
  },
};

const TeamPageReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.TEAM_PAGE_FETCH_REQUESTED:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.TEAM_PAGE_FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        active: action.payload.active,
        pending: action.payload.pending,
        inactive: action.payload.inactive,
        totals: action.payload.totals,
      };
    case types.TEAM_PAGE_FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error || true,
      };
    default:
      return state;
  }
};

export default TeamPageReducer;
